/**
 * 黑名单
 */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import { XInput, XSelect, XDatePicker, XOKButton, XCancelButton } from '@/components/xqxc_ui';
import TableContent from './components/TableContent';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import model from '@/reducers/user/black/model';
import LockDown from './modal/LockDown';
import { connect } from 'react-redux';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

class Main extends React.Component {

    state = {
        openModalType: '',
        openModalParam: {},
        tel: '',  // 手机号码
        accountType: {}, // 会员状态
        gmtDisableStart: undefined, // 注册开始时间
        gmtDisableEnd: undefined, // 注册结束时间
    };

    componentDidMount() {
        this.props.getAccountTypeEnum();
        this.props.setBreadcrumbPaths(this.props.match); // 自动识别面包屑
    }

    // 表格操作
    _tableAction = (type, record) => {
        const { history } = this.props;
        const { blockAccountId, tel, blockAccountTypeValue, blockType } = record;
        switch (type) {
            case 'history':
                history.push({ pathname: '/home/user/black/history/' + blockAccountId + '/' + blockType });
                break;
            case 'lockdown':
                this.setState({ openModalType: 'lockdown', openModalParam: { id: blockAccountId, tel, type: blockAccountTypeValue, blockType } });
                break;
        }
    }

    // 渲染弹窗
    _renderModal = () => {
        const { openModalType, openModalParam } = this.state;
        switch (openModalType) {
            case 'lockdown':
                return <LockDown data={openModalParam} closeModal={this._closeModal} />;
            default:
                return null;
        }
    }

    // 关闭弹窗
    _closeModal = (update) => {
        this.setState({ openModalType: '', openModalParam: {} }, () => {
            if (update) {
                this._searchHandle('useCache');
            }
        });
    }

    // 查询触发
    _searchHandle = (useCache) => {
        const { pageNum, pageSize, tel, accountType, gmtDisableStart, gmtDisableEnd } = this.state;
        const query = {
            tel: tel ? tel : undefined,
            blockAccountType: accountType.code,
            gmtDisableStart: gmtDisableStart ? gmtDisableStart : undefined,
            gmtDisableEnd: gmtDisableEnd ? gmtDisableEnd : undefined,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum,
            pageSize: useCache == 'useCache' ? pageSize : autopageSize,
        };
        this.props.getBlackList(query);
        KeepAlive.saveCache({ ...this.state, pageNum: query.pageNum, pageSize: query.pageSize });
    }

    // 重置触发
    _resetHandle = () => {
        this.setState({ tel: '', accountType: {}, gmtDisableStart: undefined, gmtDisableEnd: undefined }, () => {
            KeepAlive.saveResetFunc(this._searchHandle);
        });
    }

    // 每页pageSize条，当前第pageNum页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageSize, pageNum }, () => {
            this._searchHandle('useCache');
        });
    }

    render() {
        const { tel, accountType, gmtDisableStart, gmtDisableEnd } = this.state;
        const { blackList, accountTypeEnum } = this.props;

        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache');
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                label='手机号码'
                                placeholder='请输入手机号码'
                                value={tel}
                                bindThis={this}
                                bindName='tel'
                                maxLength={11}
                                mode='number'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                label='账户类型'
                                placeholder='请选择账户类型'
                                renderData={accountTypeEnum}
                                dataIndex='value'
                                keyIndex='code'
                                value={accountType.value}
                                bindThis={this}
                                bindName='accountType'
                                showSearch={true}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XDatePicker
                                label='封禁周期'
                                value={gmtDisableStart}
                                bindThis={this}
                                bindName='gmtDisableStart'
                                showTime={false}
                                defaultTime='00:00:00'
                            />
                            <XDatePicker
                                style={{ marginRight: '20px' }}
                                label=''
                                value={gmtDisableEnd}
                                bindThis={this}
                                bindName='gmtDisableEnd'
                                showTime={false}
                                defaultTime='23:59:59'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <TableContent
                        renderData={blackList}
                        tableAction={this._tableAction}
                        paginationChange={this._paginationChange}
                    />
                    {this._renderModal()}
                </div>
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    match: PropTypes.object,
    history: PropTypes.object, // 路由
    getBlackList: PropTypes.func,
    blackList: PropTypes.object,
    getAccountTypeEnum: PropTypes.func,
    accountTypeEnum: PropTypes.array,
    setBreadcrumbPaths: PropTypes.func,
};

const mapStateToProps = (state) => ({
    blackList: state.black.getBlackList,
    accountTypeEnum: state.black.getAccountTypeEnum,
});
export default connect(mapStateToProps, { ...model.actions, setBreadcrumbPaths })(Main);